import { __extends } from "tslib";
import { AVMStage } from "@awayfl/swf-loader";
import { AVM2Handler } from "@awayfl/avm2";
import { PlayerGlobal } from '@awayfl/playerglobal';
var AVM2Player = /** @class */ (function (_super) {
    __extends(AVM2Player, _super);
    function AVM2Player(gameConfig) {
        var _this = _super.call(this, gameConfig) || this;
        _this.registerAVMStageHandler(new AVM2Handler(new PlayerGlobal()));
        return _this;
    }
    return AVM2Player;
}(AVMStage));
export { AVM2Player };
